export default "__VITE_ASSET__BWOJEtl7__"